var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFortnite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 12C8 17.5011 8.01361 22 8.03175 22C8.05896 22 11.7551 21.3152 12.2086 21.2245L12.4444 21.1791V17.5057V13.8367H13.8503H15.2562V13.1655C15.2562 12.7982 15.2698 11.8413 15.288 11.034L15.3152 9.5737H13.8821H12.4444V7.96372V6.35374H14.0998C15.0113 6.35374 15.7551 6.34467 15.7551 6.33107C15.7551 6.28118 16.1179 2.40816 16.1406 2.21315L16.1678 2H12.0816H8V12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortnite);
export default __webpack_public_path__ + "static/media/fortnite.9796a76a9f8f512515ccc0f5914ca3d8.svg";
export { ForwardRef as ReactComponent };